import { POA_API_URL } from '../../../config';

export const postPingEvent = ({ articleId, userId }) => {
  const event = {
    articleId,
    userId,
    event: 'ping',
  };
  fetch(`${POA_API_URL}/event`, {
    method: 'POST',
    body: JSON.stringify(event),
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
  }).catch((e) => {
    // eslint-disable-next-line no-console
    console.error(e);
  });
};
